const register = {
  loginCredentials: "Kredensial Masuk", // translated
  companyInformation: "informasi perusahaan", // translated
  contactDetails: "Detail Kontak", // translated
  businessName: "Nama Bisnis", // translated
  businessAddress: "Alamat bisnis", // translated
  registrationCode: "Kode registrasi", // translated
  businessRegistrationNumber: "Nomor Registrasi Bisnis", // translated
  websiteUrl: "alamat situs web", // translated
  mobilePhone: "Telepon genggam", // translated
  regionStateProvince: "Wilayah/Negara Bagian/Provinsi", // translated
  legalTitle: "Judul legal", // translated
  city: "Kota", // translated
  postalCode: "Kode Pos", // translated
  registrationSuccess: "Registrasi berhasil.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Silakan tunggu beberapa saat dan Anda akan diarahkan ke halaman beranda.", // translated
  usernameEmail: "Nama pengguna (email)", // translated
  password: "Kata sandi", // translated
  verifyPassword: "Verifikasi kata sandi", // translated
  documents: "Dokumen", // translated
  termsAndConditionsSection: "Syarat & Ketentuan", // translated
  certificateOfIncorporation: "Akta Pendirian", // translated
  acceptTermsAndConditions: "Terima Syarat & Ketentuan", // translated
  country: "Negara", // translated
  brandName: "Nama merek", // translated
  register: "Daftar", // translated
  isRequired: "Wajib diisi", // translated
  passwordMin8Chars: "Harus memiliki minimal 8 karakter", // translated
  passwordRequiresDigit: "Harus mengandung minimal 1 angka", // translated
  passwordRequiresLowercase: "Harus mengandung minimal 1 huruf kecil", // translated
  passwordRequiresUppercase: "Harus mengandung minimal 1 huruf besar", // translated
  passwordRequiresSpecialChar: 'Harus mengandung minimal 1 karakter khusus (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Unggah file", // translated
  filename: "Nama file:", // translated
  fileType: "Jenis:", // translated
  fileSize: "Ukuran:", // translated
  maxFileSize10Mb: "Maks: 10MB", // translated
  supportedFileTypes: "Jenis file yang didukung:", // translated
  showPassword: "Tampilkan kata sandi", // translated
  hidePassword: "Sembunyikan kata sandi", // translated
  notAvailable: "Tidak tersedia", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "mis. +628123456789", // translated
  websiteUrlPlaceholder: "http://www.contoh.com", // translated
  loading: "Memuat...", // translated
  uploadingDocument: "Mengunggah dokumen...", // translated
  percentUploaded: "{{percent}}% diunggah", // translated
  registrationSuccessful: "Registrasi berhasil.", // translated
  failedToUploadDocument: "Gagal mengunggah dokumen.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} harus lebih dari {{min}} karakter", // translated
  fieldMustBeValidEmail: "{{field}} harus berupa email yang valid", // translated
  fieldPasswordMinLength: "{{field}} harus memiliki minimal 8 karakter", // translated
  fieldPasswordRequiresDigit: "{{field}} harus mengandung minimal 1 angka", // translated
  fieldPasswordRequiresLowercase: "{{field}} harus mengandung minimal 1 huruf kecil", // translated
  fieldPasswordRequiresUppercase: "{{field}} harus mengandung minimal 1 huruf besar", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} harus mengandung minimal 1 karakter khusus (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} tidak cocok dengan {{otherField}}", // translated
  fieldBetweenLength: "{{field}} harus antara {{min}} dan {{max}} karakter", // translated
  postalCodeBetweenLength: "{{field}} harus antara {{min}} dan {{max}} karakter", // translated
  invalidUrlFormat: "Format URL tidak valid", // translated
  invalidEmailFormat: "Format email tidak valid", // translated
  emailMustMatchUsername: "email harus sama dengan nama pengguna (email)", // translated
  mobilePhoneIsRequired: "Telepon seluler wajib diisi", // translated
  certificateFileTooLarge: "File akta pendirian terlalu besar", // translated
  termsMustBeAccepted: "Syarat & Ketentuan harus diterima", // translated
};


export default register;
